import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBottomBar from '@/components/feature/MobileBottomBar';

export default function DataPolicyPage() {
  return (
    <>
      <Navbar />
      <main className="pb-16 md:pb-0 pt-24 md:pt-28">
        <div className="mx-auto px-4 md:px-6 py-12 md:py-16" style={{ maxWidth: '860px' }}>
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-2">
            Политика обработки персональных данных
          </h1>
          <p className="text-sm text-foreground-500 mb-10">Последнее обновление: июль 2025 г.</p>

          <div className="flex flex-col gap-8 text-sm md:text-base text-foreground-700 leading-relaxed">
            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">1. Оператор персональных данных</h2>
              <p>Оператором персональных данных является мастерская «Художественная ковка», расположенная в г. Приютово, Республика Башкортостан.</p>
              <p className="mt-3">Контактный телефон: <a href="tel:+79174131562" className="text-primary-600 hover:text-primary-500">+7 917 413-15-62</a></p>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">2. Правовые основания обработки</h2>
              <p>Обработка персональных данных осуществляется на основании:</p>
              <ul className="list-disc pl-5 mt-2 flex flex-col gap-2">
                <li>Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных»;</li>
                <li>Согласия субъекта персональных данных;</li>
                <li>Договорных отношений с субъектом персональных данных.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">3. Состав обрабатываемых данных</h2>
              <ul className="list-disc pl-5 flex flex-col gap-2">
                <li>Фамилия, имя, отчество;</li>
                <li>Номер телефона;</li>
                <li>Адрес электронной почты;</li>
                <li>Адрес объекта (для выполнения замера и монтажа);</li>
                <li>Иные данные, предоставленные субъектом добровольно.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">4. Цели обработки персональных данных</h2>
              <ul className="list-disc pl-5 flex flex-col gap-2">
                <li>Заключение и исполнение договора на изготовление и монтаж изделий;</li>
                <li>Связь с клиентом для расчёта стоимости и согласования заказа;</li>
                <li>Уведомление о ходе выполнения заказа;</li>
                <li>Ведение внутреннего учёта и документооборота.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">5. Порядок и условия обработки</h2>
              <p>Обработка персональных данных осуществляется без передачи в базы данных, расположенные на территории иностранных государств. Данные хранятся не дольше, чем требуется для достижения целей обработки или до момента отзыва согласия субъектом.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">6. Права субъекта персональных данных</h2>
              <p>Субъект персональных данных вправе:</p>
              <ul className="list-disc pl-5 mt-2 flex flex-col gap-2">
                <li>Получить информацию об обработке своих данных;</li>
                <li>Требовать уточнения, блокирования или уничтожения данных;</li>
                <li>Отозвать согласие на обработку в любое время;</li>
                <li>Обжаловать действия оператора в уполномоченный орган по защите прав субъектов персональных данных (Роскомнадзор).</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">7. Меры по защите данных</h2>
              <p>Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, предоставления и распространения.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">8. Обращения и запросы</h2>
              <p>Для реализации своих прав, а также по любым вопросам, связанным с обработкой персональных данных, вы можете обратиться:</p>
              <ul className="list-none pl-0 mt-2 flex flex-col gap-1">
                <li>Телефон: <a href="tel:+79174131562" className="text-primary-600 hover:text-primary-500">+7 917 413-15-62</a></li>
                <li>WhatsApp: <a href="https://wa.me/79174131562" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-500">Написать</a></li>
                <li>Telegram: <a href="https://t.me/Gmgmg0202" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-500">Написать</a></li>
              </ul>
            </section>
          </div>
        </div>
      </main>
      <Footer />
      <MobileBottomBar />
    </>
  );
}